<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as LEAD_ORG_TYPES } from './store'
import { ROUTES as LEAD_ORG_ROUTES } from './router'
import { ROUTES as CUSTOMER_ORG_ROUTES } from '../customer-organization/router'
import { ROUTES as SUPPLIER_ORG_ROUTES } from '../supplier-organization/router'
import { ORGANIZATION_CUSTOMER_TYPE_CODE, ORGANIZATION_SUPPLIER_TYPE_CODE, ORGANIZATION_CUSTOMER_LEAD_CODE, ORGANIZATION_CUSTOMER_CODE, ORGANIZATION_SUPPLIER_CODE } from '@/const'

import OrganizationDetailMixin from '../../../components/organization/mixins/OrganizationDetailMixin'
import LeadContactList from '../../../contact/contact/lead-contact/LeadContactList'

export default {
  name: 'LeadOrganizationDetail',
  mixins: [OrganizationDetailMixin],
  components: {
    'component-contact-list': LeadContactList
  },
  data () {
    return {
      LEAD_ORG_ROUTES,
      title: 'Extra Organizations',
      routeNameList: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_LIST,
      routeDocumentNameList: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_DOCUMENTS,
      routeTaskList: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_TASK,
      orgType: ORGANIZATION_CUSTOMER_TYPE_CODE,
      showDownloadDocumentsButton: true,
      showCompanyRegistryButton: true,
      routeOrganizationInspectionList: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_INSPECTIONS_LIST,
      routeOrganizationSecurityRolesList: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_SECURITY_ROLES_LIST
    }
  },
  computed: {
    ...mapGetters({
      ...LEAD_ORG_TYPES.GENERIC.organization.customerorganization.DETAIL.GETTERS,
      groups: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.GETTERS.groups,
      organizationform: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.GETTERS.organizationform,
      typologyChoices: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.GETTERS.typologyChoices,
      employeeCategoryChoices: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.GETTERS.employeeCategoryChoices,
      orgTypeChoices: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.GETTERS.orgTypeChoices
    })
  },
  methods: {
    ...mapMutations({
      setGroups:
        LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.MUTATIONS.setGroups
    }),
    ...mapActions({
      ...LEAD_ORG_TYPES.GENERIC.organization.customerorganization.DETAIL.ACTIONS,
      getOrganizationList: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.ACTIONS.getList,
      getGroups: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.ACTIONS.getGroups,
      getOrganizationform: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.ACTIONS.getOrganizationform,
      getTypologychoices: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.ACTIONS.getTypologychoices,
      getEmployeecategorychoices: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.ACTIONS.getEmployeecategorychoices,
      getOrgtypechoices: LEAD_ORG_TYPES.GENERIC.organization.customerorganization.LIST.ACTIONS.getOrgtypechoices
    }),
    goToDetailPage (evt) {
      this.orgFilters = false
      this.showDuplicatedForm = false
      if (evt.orgTypes.includes(ORGANIZATION_CUSTOMER_LEAD_CODE)) {
        this.$router.push({ name: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_DETAIL, params: { id: evt.orgId, orgType: ORGANIZATION_CUSTOMER_LEAD_CODE } })
      } else if (evt.orgTypes.includes(ORGANIZATION_CUSTOMER_TYPE_CODE)) {
        this.$router.push({ name: CUSTOMER_ORG_ROUTES.CUSTOMER_ORGANIZATION_DETAIL, params: { id: evt.orgId, orgType: ORGANIZATION_CUSTOMER_CODE } })
      } else if (evt.orgTypes.includes(ORGANIZATION_SUPPLIER_TYPE_CODE)) {
        this.$router.push({ name: SUPPLIER_ORG_ROUTES.SUPPLIER_ORGANIZATION_DETAIL, params: { id: evt.orgId, orgType: ORGANIZATION_SUPPLIER_CODE } })
      }
    }
  }
}
</script>
